<template>
  <layout-form>
    <template v-slot:Head> </template>
    <template v-slot:Main>
      <hello-world /> 
    </template>
  </layout-form>
</template>

<script>
import layoutForm from "@/layouts/main.vue";
import HelloWorld from "@/components/HelloWorld.vue";
 

export default {
  name: "Home",
  components: {
    HelloWorld,
    layoutForm,
 
  },
  methods: {},
};
</script>
